// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLink-root-2_bTm","icon":"TextLink-icon-3zGZg"};